export default "__VITE_ASSET__CptfqqPe__"